import React from "react";

const VerifiedShieldIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.9991 1.8923L6.5871 0.5L5.2497 2.8175H2.4444V5.6768L0 7.088L1.3923 9.5L0 11.9115L2.4444 13.3232V15.9804H5.13315L6.5871 18.5L8.9991 17.1077L11.4111 18.5L12.8655 15.98H15.6384V13.2755L18 11.9115L16.6072 9.5L18 7.08845L15.6384 5.72495V2.81795H12.7498L11.4111 0.5L8.9991 1.8923ZM12.3358 6.94355L13.3501 7.9727L8.20665 13.1477L5.1309 10.0292L6.1407 9.0131L8.20485 11.0745L12.3358 6.94355Z"
      fill="currentColor"
    />
  </svg>
);

export default VerifiedShieldIcon;
